import loadContainers from '@eika-infrastruktur/ui-engine-render';
import React from 'react';
import Sparekalkulator from './components/sparekalkulator/sparekalkulator';
import Barnespar from './components/barnespar/barnespar';
import CarInsuranceCalc from './components/car-insurance-calculator/car-insurance-calc';
import Quiz from './components/Quiz/Quiz';
import { defaultConfig as sparekalkConfig } from './components/sparekalkulator/default-config';
import { defaultConfig as barnesparConfig } from './components/barnespar/default-config';
import { defaultConfig as bilforsikringConfig } from './components/car-insurance-calculator/default-config';
import { defaultConfig as quizConfig } from './components/Quiz/default-config';

require('./styles/main.scss');

loadContainers('kalkulator.sparekalkulator', (props: object) => <Sparekalkulator {...props} />, sparekalkConfig);
loadContainers('kalkulator.barnespar', (props: object) => <Barnespar {...props} />, barnesparConfig);
loadContainers('kalkulator.quiz', (props: object) => <Quiz {...props} />, quizConfig);
loadContainers(
    'kalkulator.bilforsikringskalkulator',
    (props: object) => <CarInsuranceCalc {...props} />,
    bilforsikringConfig
);
